import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-5" }

import { useGlobalStore, useConfigStore } from '@/stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'VisionAndMission',
  setup(__props) {

const globalStore = useGlobalStore();
const configStore = useConfigStore();

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6",
          class: "text-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              height: "120",
              title: _ctx.$t('OUR_VISION'),
              text: 
            _unref(configStore).stringLang(
              _unref(globalStore).organization.visionAr,
              _unref(globalStore).organization.visionEn
            )
          ,
              class: "text-center",
              variant: "flat"
            }, null, 8, ["title", "text"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6",
          class: "text-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              height: "120",
              title: _ctx.$t('OUR_MISSION'),
              text: 
            _unref(configStore).stringLang(
              _unref(globalStore).organization.missionAr,
              _unref(globalStore).organization.missionEn
            )
          ,
              class: "text-center",
              variant: "flat"
            }, null, 8, ["title", "text"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})